/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  formControl,
  FormLabel,
  Grid,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Toolbar,
  Typography,
  CardContent,
  colors, MenuItem, InputLabel
} from "@material-ui/core";

import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import Button from "@material-ui/core/Button";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Select from "react-select";
import BottomBar from "../../../components/BottomBar/BottomBar";
import { DatePicker } from "@material-ui/pickers";
import { IsEmpty } from "../../../utils/helper";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import Dropzone from "react-dropzone";

class F314CallToActionsForm extends React.Component {
  constructor(props) {
    super(props);
    const ckAdminObject = localStorage.getItem("ckAdminUser") || "{}";
    const ckAdminJsonObject = JSON.parse(ckAdminObject) || {};
    const storedToken = ckAdminJsonObject.jwttoken || "";

    this.state = {
      recordId: this.props.match.params.recordId,
      voucherCode: "",
      callToActionLabel: "",
      callToActionDescription: "",

      voucherAmountType: "1",
      voucherPercentage: "",
      voucherAmount: "",
      voucherCategoriesList: [],
      notificationTypesList: [],
      selectedVoucherCategoriesList: [],
      selectAllCategoryProducts: false,
      voucherCategoryProductList: [],
      selectedNotificationTypesList: "",
      isVoucherAvailableForAllUsers: "1",
      minimumVoucherApplicableAmount: "",
      voucherUsageLimit: "",
      userSpecificId: "",
      effectiveVoucherFrom: new Date(),
      effectiveVoucherTo: this.getTomorrowDate(),
      isVoucherReadyToSubmit: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      token: storedToken,

      usersList: [],
      selectedUsersList: [],
      selectStoreWideCategories: false,
      notification: "",
      voucherType: "1",
      isFileUploaded: 0,
      files: [],
      filesError: "",
      isFileSelected: false,
      isActive: 0,
      isLoginMenu: false,
      isReload: true,
      selectedRoute: 0,
      routesOption: [],
      selectedRoutePath: 0,
      routesPathOption: [],
    };
  }


  handleCallToActionDescriptionChange = (event) => {
    this.setState({ callToActionDescription: event.target.value });

  };


  handleRouteChange = (event) => {
    this.setState({ selectedRoute: event.target.value });

    this.getRoutesPathsData(event.target.value);

  };

  handleRoutePathChange = (event) => {
    this.setState({ selectedRoutePath: event.target.value });
  };


  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";

    switch (name) {
      case "files":
        this.setState({
          isFileSelected: value && value.length > 0,
        });
        break;
      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  //New CODE NOT DISPLAYING IMAGE
  getData = async (index) => {
    try {
      const res = await HttpRequest(
        "GET",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonCallToActionsView?recordId=${index}`,
        null,
        "authorizeJson"
      );

      if (res.isSuccess) {
        if (res.data != null && res.data.length > 0) {
          let callToActionData = res.data[0];

          // Convert timestamps to Date objects if needed
          let dateFrom = callToActionData.createdOn ? new Date(callToActionData.createdOn) : new Date();
          let dateTo = this.getTomorrowDate();

          let selectedNotificationTypeObj = null;
          if (callToActionData.notificationTypeId && this.state.notificationTypesList.length > 0) {
            selectedNotificationTypeObj = this.state.notificationTypesList.find(
              item => item.id === callToActionData.notificationTypeId
            );
          }

          let selectedVoucherCategoriesObj = null;
          if (callToActionData.categoryId && this.state.voucherCategoriesList.length > 0) {
            selectedVoucherCategoriesObj = this.state.voucherCategoriesList.find(
              item => item.id === callToActionData.categoryId
            );
          }

          let selectedUsersObj = null;
          if (callToActionData.userId && this.state.usersList.length > 0) {
            selectedUsersObj = this.state.usersList.find(
              item => item.id === callToActionData.userId
            );
          }

          // FIXED FILE HANDLING
          let filesArray = [];
          let isFileSelected = false;

          console.log("=== ENHANCED FILE LOADING DEBUG ===");
          console.log("thumbnailFileName:", callToActionData.thumbnailFileName);
          console.log("imagePath from API:", callToActionData.ImagePath);

          console.log("imageUrl from API:", callToActionData.fullImagePath);
          console.log("isImageUploaded:", callToActionData.isImageUploaded);

          if (callToActionData.thumbnailFileName) {
            // Construct the proper image URL using the same pattern as your display code
            const constructedImageUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${callToActionData.ImagePath + "/" + callToActionData.thumbnailFileName}`;

            console.log("Constructed image URL:", constructedImageUrl);

            // Create display object first (for guaranteed display)
            const displayFileObject = {
              name: callToActionData.thumbnailFileName,
              path: callToActionData.folderPath,
              fullPath: callToActionData.fullImagePath,
              url: constructedImageUrl  // Use constructed URL
            };

            // Set files array with display object
            filesArray = [displayFileObject];

            // Try to fetch the actual file for submission
            try {
              console.log("Attempting to fetch file from:", constructedImageUrl);
              const imageResponse = await fetch(constructedImageUrl);
              console.log("Fetch response status:", imageResponse.status);

              if (imageResponse.ok) {
                const blob = await imageResponse.blob();
                console.log("Blob received - size:", blob.size, "type:", blob.type);

                if (blob && blob.size > 0) {
                  // Create proper File object from blob
                  const file = new File([blob], callToActionData.thumbnailFileName, {
                    type: blob.type || 'image/jpeg',
                    lastModified: Date.now()
                  });

                  console.log("File created from blob:", {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    isFile: file instanceof File,
                    isBlob: file instanceof Blob
                  });

                  // Add metadata for display
                  file.path = callToActionData.folderPath;
                  file.fullPath = callToActionData.fullImagePath;
                  file.url = constructedImageUrl;

                  // Replace display object with actual File
                  filesArray = [file];
                  isFileSelected = true;

                  console.log("✅ SUCCESS: Created submittable File object");
                } else {
                  console.log("❌ Empty blob received");
                  isFileSelected = false;
                }
              } else {
                console.log("❌ Fetch failed with status:", imageResponse.status);
                isFileSelected = false;
              }
            } catch (fetchError) {
              console.log("❌ Fetch error:", fetchError.message);
              isFileSelected = false;
            }
          } else {
            console.log("❌ No thumbnail file name");
            filesArray = [];
            isFileSelected = false;
          }

          console.log("Final files array:", filesArray);
          console.log("Final isFileSelected:", isFileSelected);
          console.log("=== END ENHANCED FILE LOADING DEBUG ===");

          // Map the call-to-action data to your state
          this.setState({
            // Basic Call To Action fields
            callToActionLabel: callToActionData.label || "",
            callToActionDescription: callToActionData.description || "",
            notification: callToActionData.notificationMsg || "",

            // Route/Navigation fields
            selectedRoute: callToActionData.pageRouteId || 0,
            selectedRoutePath: callToActionData.pageRoutePathId || 0,

            // User availability
            isVoucherAvailableForAllUsers: callToActionData.isAvailableForAll ? callToActionData.isAvailableForAll.toString() : "1",
            userSpecificId: callToActionData.userId || "",
            selectedUsersList: selectedUsersObj,

            // File/Image fields - FIXED
            files: filesArray,
            isFileUploaded: callToActionData.isImageUploaded,
            isFileSelected: isFileSelected,

            // Date fields
            effectiveVoucherFrom: dateFrom,
            effectiveVoucherTo: dateTo,

            // Status
            isActive: callToActionData.isActive || 0,

            // Store the complete data for reference
            Data: res.data || [],

            // Clear any previous errors
            filesError: "",

            // Additional fields
            selectedVoucherCategoriesList: selectedVoucherCategoriesObj,
            selectedNotificationTypesList: selectedNotificationTypeObj,

            userLabel: callToActionData.userLabel,
            createdByUserLabel: callToActionData.createdByUserLabel
          });

          // Load route path options
          if (callToActionData.pageRouteId) {
            this.getRoutesPathsData(callToActionData.pageRouteId);
          }

          console.log("Call To Action data loaded successfully");

        } else {
          console.log("No call-to-action data found for recordId:", index);
          this.handleSnackbar(true, "No data found for the specified record", "warning");
        }
      } else {
        // API call failed
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
          });
        } else {
          this.handleSnackbar(true, res.message || "Failed to load data", "error");
        }
      }
    } catch (error) {
      console.error("Error loading call-to-action data:", error);
      this.handleSnackbar(true, "An error occurred while loading data", "error");
    }
  };


  //OLD CODE STILL DISPLAYING IMAGE
  //   getData = async (index) => {
  //   try {
  //     const res = await HttpRequest(
  //       "GET",
  //       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonCallToActionsView?recordId=${index}`,
  //       null,
  //       "authorizeJson"
  //     );

  //     if (res.isSuccess) {
  //       if (res.data != null && res.data.length > 0) {
  //         let callToActionData = res.data[0];

  //         // Convert timestamps to Date objects if needed
  //         let dateFrom = callToActionData.createdOn ? new Date(callToActionData.createdOn) : new Date();
  //         let dateTo = this.getTomorrowDate(); // Keep your existing logic for default end date
  //          // Find notification type object from the list

  //         let selectedNotificationTypeObj = null;

  //         if (callToActionData.notificationTypeId && this.state.notificationTypesList.length > 0) {
  //           selectedNotificationTypeObj = this.state.notificationTypesList.find(
  //             item => item.id === callToActionData.notificationTypeId
  //           );
  //         }

  //         let selectedVoucherCategoriesObj = null;

  //         if (callToActionData.categoryId && this.state.voucherCategoriesList.length > 0) {
  //           selectedVoucherCategoriesObj = this.state.voucherCategoriesList.find(
  //             item => item.id === callToActionData.categoryId
  //           );
  //         }


  //            let selectedUsersObj = null;

  //         if (callToActionData.userId && this.state.usersList.length > 0) {
  //           selectedUsersObj = this.state.usersList.find(
  //             item => item.id === callToActionData.userId
  //           );
  //         }

  //         // Map the call-to-action data to your state
  //         this.setState({
  //           // Basic Call To Action fields
  //           callToActionLabel: callToActionData.label || "",
  //           callToActionDescription: callToActionData.description || "",


  //           notification: callToActionData.notificationMsg || "",

  //           // Route/Navigation fields
  //           selectedRoute: callToActionData.pageRouteId || 0,
  //           selectedRoutePath: callToActionData.pageRoutePathId || 0,



  //           // User availability
  //           isVoucherAvailableForAllUsers: callToActionData.isAvailableForAll ? callToActionData.isAvailableForAll.toString() : "1",
  //           userSpecificId: callToActionData.userId || "",
  //           selectedUsersList: selectedUsersObj,

  //           // File/Image fields
  //           files: callToActionData.thumbnailFileName ? [{
  //             name: callToActionData.thumbnailFileName,
  //             path: callToActionData.folderPath,
  //             fullPath: callToActionData.fullImagePath,
  //             url: callToActionData.imageUrl
  //           }] : [],
  //           isFileUploaded: callToActionData.isImageUploaded ,
  //           isFileSelected: callToActionData.isImageUploaded === 1,

  //           // Date fields (you might want to add these to your state if needed)
  //           effectiveVoucherFrom: dateFrom,
  //           effectiveVoucherTo: dateTo,

  //           // Status
  //           isActive: callToActionData.isActive || 0,

  //           // Store the complete data for reference
  //           Data: res.data || [],

  //           // Clear any previous errors
  //           filesError: "",

  //           // Additional fields you might want to track
  //          selectedVoucherCategoriesList: selectedVoucherCategoriesObj,
  //          selectedNotificationTypesList: selectedNotificationTypeObj,

  //           userLabel: callToActionData.userLabel,
  //           createdByUserLabel: callToActionData.createdByUserLabel
  //         });

  //         // // If you have a function to load category products, call it
  //         // if (callToActionData.categoryId) {
  //         //  // Uncomment and modify this if you have such a function
  //         //   this.getVoucherCategoriesProductData(callToActionData.categoryId);
  //         // }

  //         // If you have a function to load route options, call it
  //         if (callToActionData.pageRouteId) {
  //           //Load route path options based on selected route
  //            this.getRoutesPathsData(callToActionData.pageRouteId);
  //         }

  //         console.log("Call To Action data loaded successfully:", callToActionData);

  //       } else {
  //         // No data found
  //         console.log("No call-to-action data found for recordId:", index);
  //         this.handleSnackbar(true, "No data found for the specified record", "warning");
  //       }
  //     } else {
  //       // API call failed
  //       if (res.statusCode === 401) {
  //         this.setState({
  //           isLoginMenu: true,
  //         });
  //       } else {
  //         this.handleSnackbar(true, res.message || "Failed to load data", "error");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error loading call-to-action data:", error);
  //     this.handleSnackbar(true, "An error occurred while loading data", "error");
  //   }
  // };
  getTomorrowDate = () => {
    let a = new Date();
    a.setDate(a.getDate() + 1);
    return a;
  };

  // Fix 1: Make componentDidMount async and wait for all dropdown data to load
  componentDidMount = async () => {
    try {
      // Load all dropdown data first and wait for them to complete
      await Promise.all([
        this.getVoucherCategoriesData(),
        this.getNotificationTypesData(),
        this.getRoutesData(),
        this.getUsersData()
      ]);

      // Now load the specific record data
      const id = this.props.match.params.recordId;
      if (id != 0) {
        this.setState({
          recordId: id,
        });
        await this.getData(id);
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
      this.handleSnackbar(true, "Error loading form data", "error");
    }
  };

  // Alternative Fix 2: Sequential loading (if Promise.all doesn't work with your functions)
  componentDidMount = async () => {
    try {
      // Load dropdown data sequentially
      await this.getVoucherCategoriesData();
      await this.getNotificationTypesData();
      await this.getRoutesData();
      await this.getUsersData();

      // Then load record data
      const id = this.props.match.params.recordId;
      if (id != 0) {
        this.setState({
          recordId: id,
        });
        await this.getData(id);
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
      this.handleSnackbar(true, "Error loading form data", "error");
    }
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  setVoucherAmountType = async (e) => {
    await this.setState({
      voucherAmountType: e.target.value,
    });
    this.validateVoucherForm();
  };

  setVoucherCategoryV2 = async (e) => {
    // //debugger;
    this.state.selectedVoucherCategoriesList = [];
    this.setState({
      selectedVoucherCategoriesList: e,
    });


    //
  };

  setNotificationTypes = async (e) => {
    // //debugger;

    console.log("e", e)

    this.state.selectedNotificationTypesList = [];
    this.setState({
      selectedNotificationTypesList: e,
    });


    //
  };




  setUsers = async (e) => {
    this.state.userSpecificId = "";
    await this.setState({
      userSpecificId: e.id,
      selectedUsersList: e,
    });
  };

  getVoucherCategoriesData = async () => {
    let voucherCategoriesDataList = [];
    // e.preventDefault();
    // this.setState({
    //     isLoading: true,
    // });
    // const data = new FormData(e.target);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonProductsCategoriesView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].label,
            label: res.data[i].label,
            id: res.data[i].id,
            userLabel: res.data[i].userLabel,
            isFixed: false,
            isDisabled: false,
          };
          voucherCategoriesDataList.push(jsonNode);
        }
        this.setState({
          voucherCategoriesList: voucherCategoriesDataList,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    // this.setState({
    //     isLoading: false,
    // });
  };

  getNotificationTypesData = async () => {
    let notificationTypesDataList = [];
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonNotificationTypesView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].label,
            label: res.data[i].label,
            id: res.data[i].id,
            userLabel: res.data[i].userLabel,
            isFixed: false,
            isDisabled: false,
          };
          notificationTypesDataList.push(jsonNode);
        }
        this.setState({
          notificationTypesList: notificationTypesDataList,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

  };


  getRoutesData = async () => {
    let notificationTypesDataList = [];
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314MobileApplicationRouteView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {


        this.setState({
          routesOption: res.data,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

  };


  getRoutesPathsData = async (selectedRouteId) => {


    const data = new FormData();
    data.append("routeId", selectedRouteId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314MobileApplicationRoutePathsView`,
      data,
      "authorize"
    );
    console.log(res)
    if (res.isSuccess) {

      if (res.data != null && res.data.length > 0) {

        this.setState({
          routesPathOption: res.data,
        });
      }
    } else {


      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

  };

  // getVoucherCategoriesProductData = async (selectedVoucherCategoriesList) => {
  //   let voucherCategoryProductDataList = [];
  //   // e.preventDefault();
  //   // this.setState({
  //   //     isLoading: true,
  //   // });
  //   // const data = new FormData(e.target);
  //   if (selectedVoucherCategoriesList.length > 0) {
  //     const data = new FormData();
  //     for (let i = 0; i < selectedVoucherCategoriesList.length; i++) {
  //       data.append("categoryId", selectedVoucherCategoriesList[i].id);
  //     }
  //     const res = await HttpRequest(
  //       "POST",
  //       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonNotificationTypesView`,
  //       data,
  //       "authorize"
  //     );
  //     if (res.isSuccess) {
  //       if (res.data != null && res.data.length > 0) {
  //         for (let i = 0; i < res.data.length; i++) {
  //           let jsonNode = {
  //             value: res.data[i].label,
  //             label: res.data[i].label,
  //             id: res.data[i].id,
  //             userLabel: res.data[i].userLabel,
  //             isFixed: false,
  //             isDisabled: false,
  //           };
  //           voucherCategoryProductDataList.push(jsonNode);
  //         }
  //         this.setState({
  //           voucherCategoryProductList: voucherCategoryProductDataList,
  //         });
  //       }
  //     } else {
  //       if (res.statusCode === 401) {
  //         this.setState({
  //           isLoginMenu: true,
  //         });
  //       } else {
  //         this.handleSnackbar(true, res.message, "error");
  //       }
  //     }
  //   }


  // };

  getGeneratedVoucherCodeFromServer = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersGenerateView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        const vCode = res.data[0]["voucherCode"];
        await this.setState({
          voucherCode: vCode,
        });
        this.validateVoucherForm();
      }
    } else {
      // if (res.statusCode === 401) {
      //     this.setState({
      //         isLoginMenu: true,
      //         isReload: false,
      //     });
      // } else {
      //     this.handleSnackbar(true, res.message, "error");
      // }
    }
  };

  getUsersData = async () => {
    let usersList = [];
    // e.preventDefault();
    // this.setState({
    //     isLoading: true,
    // });
    // const data = new FormData(e.target);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonUsersView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].id,
            label: res.data[i].id + " - " + res.data[i].displayName,
            id: res.data[i].id,
            userLabel: res.data[i].displayName,
            isFixed: false,
            isDisabled: false,
          };
          usersList.push(jsonNode);
        }
        this.setState({
          usersList: usersList,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    // this.setState({
    //     isLoading: false,
    // });
  };

  onClickSubmit = () => {
    document.getElementById("F314FromSubmitButton").click();
  };

  // SIMPLE APPROACH: Update submitVoucher to handle existing files differently
  // SIMPLE APPROACH: Update submitVoucher to handle existing files differently
  submitVoucher = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const isVoucherAvailableForAll = this.state.isVoucherAvailableForAllUsers;

    const callToActionLabel = this.state.callToActionLabel;
    const callToActionDescription = this.state.callToActionDescription;
    const pageRoute = this.state.selectedRoute;
    const mobilePageRoute = this.state.selectedRoutePath;

    let selectedNotificationTypeId;
    if (this.state.selectedNotificationTypesList != "") {
      selectedNotificationTypeId = this.state.selectedNotificationTypesList.id;
    } else {
      this.handleSnackbar(true, "Please select notification type.", "error");
      return false;
    }

    let selectedCatgeoryId;
    if (this.state.selectedVoucherCategoriesList != "") {
      selectedCatgeoryId = this.state.selectedVoucherCategoriesList.id;
    } else {
      this.handleSnackbar(true, "Please select product categories.", "error");
      return false;
    }

    if (!callToActionLabel) {
      this.handleSnackbar(true, "Please enter call to action label.", "error");
      return false;
    }

    if (!callToActionDescription) {
      this.handleSnackbar(true, "Please enter call to action description.", "error");
      return false;
    }

    if (!this.state.notification) {
      this.handleSnackbar(
        true,
        "Please enter notification text.",
        "error"
      );
      return false;
    }

    let userId = !IsEmpty(this.state.selectedUsersList)
      ? this.state.selectedUsersList.id
      : "";
    const userSpecificId = userId;

    const notification = this.state.notification;

    data.append("recordId", this.state.recordId);
    data.append("callToActionLabel", callToActionLabel);
    data.append("callToActionDescription", callToActionDescription);
    data.append("pageRouteId", pageRoute);
    data.append("pagePathRouteId", mobilePageRoute);
    data.append("categoryId", selectedCatgeoryId);
    data.append("notificationTypeId", selectedNotificationTypeId);

    data.append("isAvaliableForAll", isVoucherAvailableForAll);
    if (isVoucherAvailableForAll === "0") {
      data.append("userId", userSpecificId);
    }

    data.append("notificationMsg", notification);

    // SIMPLIFIED FILE HANDLING
    console.log("=== SIMPLE FILE DEBUG ===");
    console.log("Files array:", this.state.files);
    console.log("Files length:", this.state.files ? this.state.files.length : 0);
    console.log("isFileSelected:", this.state.isFileSelected);
    console.log("isFileUploaded:", this.state.isFileUploaded);

    // Check if we have files and user wants to include them
    if (this.state.files && this.state.files.length > 0 && this.state.isFileSelected) {
      const fileObj = this.state.files[0];
      console.log("Processing file:", fileObj);

      // If it's a proper File object from user upload (has File prototype)
      if (fileObj instanceof File) {
        console.log("✅ NEW FILE: Appending File object:", fileObj.name, fileObj.size);
        data.append("file", fileObj);
      }
      // If it's from our fetch (should be File but check for Blob as backup)
      else if (fileObj instanceof Blob) {
        console.log("✅ FETCHED FILE: Appending Blob:", fileObj.size);
        data.append("file", fileObj, fileObj.name || "image.jpg");
      }
      // If it's a regular file-like object with size
      else if (fileObj.size && fileObj.size > 0) {
        console.log("✅ REGULAR FILE: Appending file-like object:", fileObj.name, fileObj.size);
        data.append("file", fileObj);
      }
      // If it's just metadata (no size), try to fetch it now
      else if (fileObj.name && fileObj.url && !fileObj.size) {
        console.log("⏳ METADATA ONLY: Attempting to fetch file now...");
        try {
          const response = await fetch(fileObj.url);
          if (response.ok) {
            const blob = await response.blob();
            if (blob.size > 0) {
              console.log("✅ FETCHED NOW: Got blob:", blob.size, "bytes");
              data.append("file", blob, fileObj.name);
            } else {
              console.log("❌ FETCH FAILED: Empty blob");
            }
          } else {
            console.log("❌ FETCH FAILED: HTTP", response.status);
          }
        } catch (err) {
          console.log("❌ FETCH ERROR:", err.message);
        }
      }
      else {
        console.log("❌ UNKNOWN FILE TYPE:", typeof fileObj, Object.keys(fileObj));
      }
    } else {
      console.log("❌ NO FILES TO SUBMIT");
    }

    // Log final FormData contents
    console.log("=== FINAL FORMDATA ===");
    for (let [key, value] of data.entries()) {
      if (key === 'file') {
        console.log(`${key}:`, value.constructor.name, value.name || 'no-name', value.size || 'no-size');
      } else {
        console.log(`${key}: ${value}`);
      }
    }
    console.log("=== END DEBUG ===");

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonCallToActionsSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  // submitVoucher = async (e) => {
  //   e.preventDefault();
  //   const data = new FormData(e.target);
  //   const isVoucherAvailableForAll = this.state.isVoucherAvailableForAllUsers;

  //   const callToActionLabel = this.state.callToActionLabel;
  //   const callToActionDescription = this.state.callToActionDescription;
  //   const pageRoute=this.state.selectedRoute;
  //   const mobilePageRoute=this.state.selectedRoutePath;



  //   let selectedNotificationTypeId ;
  //   if(this.state.selectedNotificationTypesList!=""){
  //      selectedNotificationTypeId=this.state.selectedNotificationTypesList.id;

  //   }else{
  //      this.handleSnackbar(true, "Please notification type.", "error");
  //     return false;
  //   }

  //   let selectedCatgeoryId ;
  //   if(this.state.selectedVoucherCategoriesList!=""){
  //      selectedCatgeoryId=this.state.selectedVoucherCategoriesList.id;

  //   }else{
  //      this.handleSnackbar(true, "Please product categories.", "error");
  //     return false;
  //   }


  //   if (!callToActionLabel) {
  //     this.handleSnackbar(true, "Please enter voucher label.", "error");
  //     return false;
  //   }

  //   if (!callToActionDescription) {
  //     this.handleSnackbar(true, "Please enter voucher description.", "error");
  //     return false;
  //   }




  //   if (!this.state.notification) {
  //     this.handleSnackbar(
  //       true,
  //       "Please enter voucher notification text.",
  //       "error"
  //     );
  //     return false;
  //   }





  //   let userId = !IsEmpty(this.state.selectedUsersList)
  //     ? this.state.selectedUsersList.id
  //     : "";
  //   const userSpecificId = userId;

  //   const notification = this.state.notification;


  //   data.append("recordId", this.state.recordId);

  //   data.append("callToActionLabel", callToActionLabel);
  //   data.append("callToActionDescription", callToActionDescription);
  //   data.append("pageRouteId", pageRoute);
  //   data.append("pagePathRouteId", mobilePageRoute);
  //   data.append("categoryId",selectedCatgeoryId)
  //   data.append("notificationTypeId",selectedNotificationTypeId)






  //   data.append("isAvaliableForAll", isVoucherAvailableForAll);
  //   if (isVoucherAvailableForAll === "0") {
  //     data.append("userId", userSpecificId);
  //   }


  //   data.append("notificationMsg", notification);

  //   if (

  //     this.state.isFileSelected &&
  //     this.state.files &&
  //     this.state.files.length > 0
  //   ) {
  //     data.append("file", this.state.files[0]);
  //   }

  //   const res = await HttpRequest(
  //     "POST",
  //     `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonCallToActionsSave`,
  //     data,
  //     "authorize"
  //   );

  //   if (res.isSuccess) {
  //     this.handleSnackbar(true, "Saved", "success");
  //     window.location.reload();
  //   } else {
  //     if (res.statusCode === 401) {
  //       this.setState({
  //         isLoginMenu: true,
  //         isReload: false,
  //       });
  //     } else {
  //       this.handleSnackbar(true, res.message, "error");
  //     }
  //   }
  // };

  viewReport = async () => {
    window.location = "#/F314CallToActionsReport";
  };

  setVoucherCategoryProductV2 = async (e) => {
    this.state.selectedVoucherCategoriesProductList = [];
    await this.setState({
      selectedVoucherCategoriesProductList: e,
    });
    this.validateVoucherForm();
  };

  updateAllCategoryProductsSelection = async (e) => {
    await this.setState({
      selectAllCategoryProducts: e.target.checked,
      selectedVoucherCategoriesProductList: [],
    });
    this.validateVoucherForm();
  };

  updateStoreWideCategoriesSelection = async (e) => {
    await this.setState({
      selectStoreWideCategories: e.target.checked,
    });
    //this.validateVoucherForm();
  };

  setVoucherType = async (e) => {
    await this.setState({
      voucherType: e.target.value,
    });
  };

  setVoucherAvailableForAll = async (e) => {
    await this.setState({
      isVoucherAvailableForAllUsers: e.target.value,
    });
    this.validateVoucherForm();
  };

  setEffectiveFrom = (date) => {
    // let date = e.target.value;
    // const arr = date.split("-");
    // const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    this.setState({
      effectiveVoucherFrom: date,
    });
    // this.validateVoucherForm();
  };

  setEffectiveTo = (date) => {
    // let date = e.target.value;
    // const arr = date.split("-");
    // const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    this.setState({
      effectiveVoucherTo: date,
    });
    // this.validateVoucherForm();
  };

  validateVoucherForm() {
    //Validate All Users or UserSpecific

    let isAllFieldsValidated;
    if (this.state.isVoucherAvailableForAllUsers === "1") {
      isAllFieldsValidated = true;
    } else {
      if (this.state.userSpecificId) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.callToActionLabel) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.callToActionDescription) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherCode) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }
    if (this.state.voucherAmountType === "1") {
      if (this.state.voucherPercentage) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      if (this.state.voucherAmount) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.selectedVoucherCategoriesList.length > 0) {
      isAllFieldsValidated = true;
      if (
        this.state.selectedVoucherCategoriesProductList.length > 0 ||
        this.state.selectAllCategoryProducts
      ) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.minimumVoucherApplicableAmount) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherUsageLimit) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherFrom) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherTo) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.notification) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (isAllFieldsValidated) {
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
    }
  }

  onDrop = (files) => {
    if (files.length > 0) {
      this.setState({
        files,
        isFileSelected: true,
      });
    } else {
      this.setState({
        isFileSelected: false,
      });
    }
  };

  render() {
    const { voucherAmountType } = this.state;
    let { usersList } = this.state;
    let { voucherCategoriesList } = this.state;
    let { selectedVoucherCategoriesList } = this.state;
    let { notificationTypesList } = this.state;
    let { selectedNotificationTypesList } = this.state;
    let { selectStoreWideCategories } = this.state;
    let { isVoucherAvailableForAllUsers } = this.state;
    let { selectedRoute } = this.state;
    let { routesOption } = this.state;
    let { selectedRoutePath } = this.state;
    let { routesPathOption } = this.state;
    const { classes } = this.props;




    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <Grid
          container
          xs={12}
          direction={"column"}
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Call To Actions Dashboard" />
            {/* <LoginMenu 
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                    /> */}
          </Toolbar>
          <Card
            style={{
              width: "98%",
              height: "auto",
              paddingTop: 20,
              paddingBottom: 100,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <TextField type="hidden" name="id" value={this.state.recordId} />


            <div style={{ width: "100%", marginBottom: 10 }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <TextField
                  id="call-to-action-label"
                  label="Call to Action Label"
                  variant="outlined"
                  size="small"
                  value={this.state.callToActionLabel}
                  onChange={(val) => {
                    // eslint-disable-next-line react/no-direct-mutation-state
                    this.state.callToActionLabel = val.target.value;
                    this.validateVoucherForm();
                  }}
                  style={{ width: "49.5%" }}
                />
                <div style={{ width: "1%" }} />
                <TextField
                  id="voucher-description"
                  label="Description"
                  variant="outlined"
                  size="small"
                  value={this.state.callToActionDescription}
                  inputProps={{
                    maxLength: 50

                  }}
                  style={{ width: "49.5%" }}
                  onChange={this.handleCallToActionDescriptionChange}
                />


              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "left",
                  marginBottom: "20px",
                }}
              >
                <Grid
                  container
                  item
                  xs={6}

                >
                  <TextField

                    value={selectedRoute}
                    onChange={this.handleRouteChange}
                    label="Page Route"
                    select
                    fullWidth
                    variant="outlined"
                    size="small"
                  >

                    {routesOption.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <div style={{ width: "1%" }} />

                <Grid
                  container
                  item
                  xs={6}

                >
                  <TextField

                    value={selectedRoutePath}
                    onChange={this.handleRoutePathChange}
                    label="Mobile App Path"
                    select
                    fullWidth
                    variant="outlined"
                    size="small"
                  >

                    {routesPathOption.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.urlPath}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>




              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <Grid
                  container
                  item
                  xs={6}
                  style={{
                    position: "relative",
                    zIndex: 10,
                  }}
                >

                  <Grid item xs={12} style={{ paddingBottom: 20, marginRight: 10 }}>

                    <div className="form-group">
                      {/* <label htmlFor="notification-types" style={{color: rgba(0, 0, 0, 0.54)}}>Notification Types</label> */}
                      <Select
                        inputId="notification-types"
                        value={selectedNotificationTypesList}
                        isMulti={false}
                        name="notificationTypesList"
                        options={notificationTypesList}
                        onChange={e => this.setNotificationTypes(e)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: base => ({
                            ...base,
                            background: "#FFFFFF",
                            backgroundColor: "#FFFFFF",
                          }),
                        }}
                        isDisabled={false}
                        placeholder="Select notification types..."
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  style={{
                    position: "relative",
                    zIndex: 10,
                  }}
                >

                  <Grid item xs={12} style={{ paddingBottom: 20 }}>
                    <div className="form-group">
                      {/* <label htmlFor="notification-types" style={{color: rgba(0, 0, 0, 0.54)}}>Notification Types</label> */}
                      <Select
                        inputId="categories-types"
                        value={selectedVoucherCategoriesList}
                        isMulti={false}
                        name="voucherCategoriesList"
                        options={voucherCategoriesList}
                        onChange={e => this.setVoucherCategoryV2(e)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: base => ({
                            ...base,
                            background: "#FFFFFF",
                            backgroundColor: "#FFFFFF",
                          }),
                        }}
                        isDisabled={selectStoreWideCategories}
                        placeholder="Select categories ..."
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>




              {/* {this.state.isFileUploaded  === 0 && (
                <Dropzone
                  accept={"image/png, image/jpeg"}
                  onDrop={this.onDrop}
                  multiple={false}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div
                        style={{ textAlign: "center" }}
                        {...getRootProps({
                          className: "dropzone",
                          onChange: (event) =>
                            this.handleChange({
                              target: {
                                name: "files",
                                value: event.target.files || [],
                              },
                            }),
                        })}
                      >
                        <Card
                          style={{
                            backgroundColor: "#c7c7c7",
                            marginTop: 10,
                          }}
                        >
                          <CardContent
                            style={{
                              paddingBottom: 18,
                            }}
                          >
                            <input name="file" {...getInputProps()} />
                            <Typography
                              style={{ cursor: "pointer" }}
                              variant="subtitle1"
                              color={
                                this.state.files.length > 0 ? "primary" : ""
                              }
                            >
                              {/* [{path: "fileName", size: "60kb"}] */}

              {/* isSelected = false; * /}

                              {this.state.files.length > 0
                                ? `${this.state.files[0].path}`
                                : `Please click to select a file or drop your file here`}
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    </section>
                  )}
                </Dropzone>
              )} */}





              {/* Enhanced File Upload/Display Section */}
              <div style={{ marginTop: 20, marginBottom: 20 }}>
                <Typography variant="subtitle2" style={{ marginBottom: 10, fontWeight: 600 }}>
                  Call to Action Image
                </Typography>

                {this.state.isFileUploaded === 0 && (
                  <Dropzone
                    accept={"image/png, image/jpeg, image/jpg, image/gif"}
                    onDrop={this.onDrop}
                    multiple={false}
                    maxSize={5242880} // 5MB limit
                  >
                    {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                      <section>
                        <div
                          style={{ textAlign: "center" }}
                          {...getRootProps({
                            className: "dropzone",
                            onChange: (event) =>
                              this.handleChange({
                                target: {
                                  name: "files",
                                  value: event.target.files || [],
                                },
                              }),
                          })}
                        >
                          <Card
                            style={{
                              backgroundColor: isDragActive
                                ? "#e3f2fd"
                                : isDragReject
                                  ? "#ffebee"
                                  : "#f5f5f5",
                              marginTop: 10,
                              border: isDragActive
                                ? "2px dashed #2196f3"
                                : isDragReject
                                  ? "2px dashed #f44336"
                                  : "2px dashed #ccc",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                            }}
                          >
                            <CardContent
                              style={{
                                paddingBottom: 18,
                                padding: 30,
                              }}
                            >
                              <input name="file" {...getInputProps()} />
                              <div style={{ marginBottom: 10 }}>
                                <i
                                  className="fas fa-cloud-upload-alt"
                                  style={{ fontSize: 48, color: "#999" }}
                                />
                              </div>
                              <Typography
                                style={{ cursor: "pointer" }}
                                variant="subtitle1"
                                color={this.state.files.length > 0 ? "primary" : "textSecondary"}
                              >
                                {this.state.files.length > 0
                                  ? `Selected: ${this.state.files[0].name || this.state.files[0].path}`
                                  : isDragActive
                                    ? "Drop the image here..."
                                    : "Click to select an image or drag and drop"}
                              </Typography>
                              <Typography variant="caption" display="block" style={{ marginTop: 5 }}>
                                Supported formats: PNG, JPG, JPEG, GIF (Max 5MB)
                              </Typography>
                            </CardContent>
                          </Card>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                )}

                {/* Enhanced image display with additional actions */}
                {this.state.isFileUploaded === 1 && (
                  <Card
                    style={{
                      marginTop: 10,
                      position: "relative",
                      border: "1px solid #e0e0e0",
                      overflow: "hidden",
                    }}
                  >
                    <CardContent
                      style={{
                        paddingBottom: 16,
                        textAlign: "center",
                      }}
                    >
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 15
                      }}>
                        <Typography
                          variant="subtitle2"
                          style={{ color: "#4caf50", fontWeight: 600 }}
                        >
                          ✓ Call to Action Image
                        </Typography>
                        <div>

                          <Button
                            variant="outlined"
                            size="small"
                            style={{ marginRight: 8 }}
                            onClick={() => {
                              this.setState({
                                isFileUploaded: 0,
                                files: [],
                                isFileSelected: false,
                              });
                            }}
                          >
                            Change
                          </Button>
                          <Button
                            variant="outlined"
                            color="secondary"
                            size="small"
                            onClick={() => {
                              this.setState({
                                isFileUploaded: 0,
                                files: [],
                                isFileSelected: false,
                              });
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>

                      {/* Main image display */}
                      {this.state.files.length > 0 && this.state.files[0].name ? (
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                            cursor: "pointer",
                            transition: "transform 0.2s ease",
                          }}
                          onClick={() => {
                            // Optional: Click to view full image
                            const imageUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${this.state.files[0].path + "/" + this.state.files[0].name}`;
                            window.open(imageUrl, '_blank');
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.02)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${this.state.files[0].path + "/" + this.state.files[0].name}`}
                            alt="Call to Action"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "400px",
                              width: "auto",
                              height: "auto",
                              border: "2px solid #e0e0e0",
                              borderRadius: "8px",
                              objectFit: "contain",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              display: "block",
                              margin: "0 auto",
                              transition: "box-shadow 0.2s ease",
                            }}
                            onError={(e) => {
                              console.error("Image failed to load");
                              e.target.style.display = "none";
                              e.target.parentNode.nextSibling.style.display = "flex";
                            }}
                            onLoad={() => {
                              console.log("Image loaded successfully");
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                            }}
                          />


                        </div>
                      ) : (
                        <div>No image available</div>
                      )}

                      {/* Error fallback (hidden by default) */}
                      <div
                        style={{
                          display: "none",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 40,
                          backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          border: "2px dashed #ccc",
                          minHeight: "200px"
                        }}
                      >
                        <div style={{ fontSize: "48px", marginBottom: 15 }}>❌</div>
                        <Typography variant="h6" style={{ color: "#666", marginBottom: 10 }}>
                          Failed to load image
                        </Typography>
                        <Typography variant="caption" style={{
                          color: "#999",
                          wordBreak: "break-all",
                          textAlign: "center",
                          maxWidth: "300px"
                        }}>
                          {this.state.files[0] ? this.state.files[0].name : "Unknown file"}
                        </Typography>
                      </div>
                    </CardContent>
                  </Card>
                )}
                {/* File upload errors */}
                {this.state.filesError && (
                  <Typography
                    variant="caption"
                    style={{ color: "#f44336", marginTop: 5, display: "block" }}
                  >
                    {this.state.filesError}
                  </Typography>
                )}
              </div>

              <form noValidate onSubmit={this.submitVoucher}>
                <input id="F314FromSubmitButton" type="submit" hidden />
              </form>
            </div>



            <FormLabel component="legend">Select Call to Action for : </FormLabel>
            {/*Is Voucher Available For All User*/}
            {/*1-> For All Users*/}
            {/*2-> User Specific*/}
            <div style={{ width: "100%", marginBottom: 10 }}>
              <RadioGroup
                row
                aria-label="voucher-available-for-all"
                name="voucher-available-for-all"
                defaultValue={"0"}
                value={isVoucherAvailableForAllUsers + ""}
                onChange={(e) => this.setVoucherAvailableForAll(e)}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="User Specific"

                />
                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="All Registered Users"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="All Un-Registered Users"
                />
              </RadioGroup>
            </div>

            <div style={{ width: "100%" }}>
              {isVoucherAvailableForAllUsers == "0" ? (
                <Grid
                  container
                  item
                  xs={6}
                  style={{
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      align="left"
                      color="textSecondary"
                      style={{ paddingBottom: 5 }}
                    >
                      Select Users
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ paddingBottom: 20 }}>
                    <Select
                      // defaultValue={}
                      // isMulti
                      value={this.state.selectedUsersList}
                      name="usersList"
                      options={usersList}
                      onChange={(e) => {
                        this.setUsers(e);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        option: (base) => ({
                          ...base,
                          background: "#FFFFFF",
                          backgroundColor: "#FFFFFF",
                        }),
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <span />
              )}
            </div>

            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid item xs={12}>
                <TextField
                  id="outlined-multiline-static"
                  label="Notification"
                  value={this.state.notification}
                  multiline
                  rows={4}
                  placeholder="Enter message to send as notification"
                  variant="outlined"
                  fullWidth
                  onChange={(val) => {
                    // eslint-disable-next-line react/no-direct-mutation-state
                    this.state.notification = val.target.value;
                    this.validateVoucherForm();
                  }}
                />
              </Grid>
              {/* <Grid item >
                                        <Button variant="contained" color={isVoucherReadyToSubmit ? "primary" : "#e0e0e0"}
                                            onClick={() => {
                                                if (isVoucherReadyToSubmit) {
                                                    this.submitVoucher();
                                                }
                                            }}>
                                                Submit
                                        </Button>
                                    </Grid>     */}
            </Grid>
          </Card>
          <BottomBar
            //rightButtonDisable={this.state.recordId == 0}
            leftButtonAction={() => this.viewReport()}
            leftButtonText="View"
            rightButtonText="Submit"
            rightButtonAction={() => this.onClickSubmit()}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
            autoHideDuration={3000}
          />
        </Grid>
      </Fragment>
    );
  }
}

F314CallToActionsForm.propTypes = {
  match: PropTypes.object,
};

F314CallToActionsForm.defaultProps = {
  match: {
    params: {},
  },
};

export default F314CallToActionsForm;
